import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { EquipmentTypeDropdownComponent }         from '../../components/DomainData/EquipmentTypeDropdown.component';
import { SectionDropdownComponent }         from '../../components/DomainData/SectionDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-modelgroup-edit',
  templateUrl: './ModelGroupEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => ModelGroupEditComponent)}]
})
export class ModelGroupEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(EquipmentTypeDropdownComponent) public equipmentTypeDropdown: EquipmentTypeDropdownComponent;
    @ViewChild(SectionDropdownComponent) public sectionDropdown: SectionDropdownComponent;

    @Input() public record: ent.ModelGroup;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'name' : '',
          'section' : '',
          'equipmentType' : '',
          'inactive' : '',
          'nonSerialized' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    sectionChange(event: any){
        
        this.record.SectionID = event;
    }

    equipmentTypeChange(event: any){
        
        this.record.EquipmentTypeID = event;
    }
}